import { UpdateLang } from "_actions";
import { logout } from "_actions";
import DigitalWatch from "components/DigitalWatch";
import i18n from "i18n";
import React from "react";
import { Translation } from "react-i18next";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Drawer, Button, Placeholder } from "rsuite";
import LangBox from "./LangBox";
import WalletBox from "./WalletBox";
import Emitter from "_actions/emitter";
import { SiteFeatures } from "config/siteFeatures";
import { IoMenuSharp } from "react-icons/io5";

export const MobileDrawer = (props) => {
  const { currentLang } = props;
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };
  return (
    <Translation>
      {(t) => (
        <>
          <div className=" drawer z-[11]">
            <input
              id="mobile-menu-drawer"
              type="checkbox"
              className="drawer-toggle"
              checked={open}
              onChange={() => setOpen(!open)}
            />
            <div className="drawer-content">
              {/* Page content here */}
              <label
                htmlFor="mobile-menu-drawer"
                className="btn btn-ghost btn-sm btn-square text-white"
              >
                <IoMenuSharp className="w-6 h-6" />
              </label>
            </div>
            {open && (
              <div
                style={{
                  backgroundImage: `url(${require("../../assets/img/bg.jpg")})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                }}
                className="drawer-side"
              >
                <label
                  htmlFor="mobile-menu-drawer"
                  aria-label="close sidebar"
                  className="drawer-overlay"
                ></label>

                <div className="p-4 w-full h-[100vh] min-h-[100vh]  *:text-base-content flex flex-col bg-secondary-500/70 justify-evenly">
                  <div className="h-[100px] flex justify-left relative">
                    <div className="mt-4">
                      <DigitalWatch textStyle={"text-xl"} />
                    </div>

                    <div
                      onClick={() => setOpen(false)}
                      className="btn btn-square btn-secondary btn-md absolute end-0 bg-secondary-600/50"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="currentColor"
                        className="w-6 h-6"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M6 18 18 6M6 6l12 12"
                        />
                      </svg>
                    </div>
                  </div>
                  <div className="flex-1 ">
                    <LangBox />
                    {props.loggedIn && <WalletBox />}
                    {props.loggedIn && SiteFeatures.DEPOSIT_SYSTEM && (
                      <div className="flex gap-2 mt-2">
                        <div
                          onClick={() => {
                            setOpen(false);
                            Emitter.emit("BALANCE_MODAL", "deposit");
                          }}
                          className="btn btn-sm btn-block flex-1 bg-gradient-to-rfrom-primary-500 via-primary-500 to-primary-500 text-white border-none font-bold uppercase tracking-wide"
                        >
                          {t("BALANCE_MODAL_DEPOSIT_BUTTON")}
                        </div>
                        <div
                          onClick={() => {
                            setOpen(false);
                            Emitter.emit("BALANCE_MODAL", "withdraw");
                          }}
                          className="btn btn-sm btn-block flex-1 bg-transparent border border-primary-400/60 text-white font-bold uppercase tracking-wide"
                        >
                          {t("BALANCE_MODAL_WITHDRAW_BUTTON")}
                        </div>
                      </div>
                    )}

                    <ul className="menu flex mt-4">
                      {/*props.permissions?.SPORTS_ACCESS?.Value && (
                        <Link
                          onClick={() => setOpen(false)}
                          className="btn btn-ghost text-left text-2xl	 mb-2 text-white flex p-0 hamburger-menu-item"
                          to="/sports"
                        >
                          {t("TITLE_SPORTS")}
                        </Link>
                      )*/}
                      {((!SiteFeatures.CLOSED_SYSTEM && !props.loggedIn) ||
                        props.permissions?.CASINO_ACCESS?.Value) && (
                        <Link
                          onClick={() => {
                            setOpen(false);
                            if (!props.loggedIn) {
                              Emitter.emit("LOGIN_MODAL", true);
                            }
                          }}
                          className="btn btn-ghost text-left text-2xl	 mb-2 text-white flex p-0 hamburger-menu-item"
                          to="/casino"
                        >
                          {t("TITLE_CASINO")}
                        </Link>
                      )}

                      {((!SiteFeatures.CLOSED_SYSTEM && !props.loggedIn) ||
                        props.permissions?.LIVECASINO_ACCESS?.Value) && (
                        <Link
                          onClick={() => {
                            setOpen(false);
                            if (!props.loggedIn) {
                              Emitter.emit("LOGIN_MODAL", true);
                            }
                          }}
                          className="btn btn-ghost text-left text-2xl mb-2 text-white flex p-0 hamburger-menu-item"
                          to="/live-casino"
                        >
                          {t("TITLE_LIVECASINO")}
                        </Link>
                      )}
                      {((!SiteFeatures.CLOSED_SYSTEM && !props.loggedIn) ||
                        props.permissions?.GAMES_ACCESS?.Value) && (
                        <Link
                          onClick={() => {
                            setOpen(false);
                            if (!props.loggedIn) {
                              Emitter.emit("LOGIN_MODAL", true);
                            }
                          }}
                          className="btn btn-ghost text-left text-2xl mb-2 text-white flex p-0 hamburger-menu-item"
                          to="/games"
                        >
                          {t("TITLE_GAMES")}
                        </Link>
                      )}

                      {((!SiteFeatures.CLOSED_SYSTEM && !props.loggedIn) ||
                        props.permissions?.VIRTUAL_ACCESS?.Value) && (
                        <Link
                          onClick={() => {
                            setOpen(false);
                            if (!props.loggedIn) {
                              Emitter.emit("LOGIN_MODAL", true);
                            }
                          }}
                          className="btn btn-ghost text-left text-2xl mb-2 text-white flex p-0 hamburger-menu-item"
                          to="/virtual"
                        >
                          {t("TITLE_VIRTUAL")}
                        </Link>
                      )}

                      {false && SiteFeatures.BONUS_SYSTEM && (
                        <Link
                          onClick={() => setOpen(false)}
                          className="btn btn-ghost text-left text-2xl mb-2 text-white flex p-0 hamburger-menu-item"
                          to="/bonus"
                        >
                          {t("TITLE_BONUS")}
                        </Link>
                      )}

                      <Link
                        onClick={() => setOpen(false)}
                        className="btn btn-ghost text-left text-2xl mb-2 text-white flex p-0 hamburger-menu-item"
                        to="/rules"
                      >
                        {t("TITLE_RULES")}
                      </Link>

                      <Link
                        onClick={() => setOpen(false)}
                        className="btn btn-ghost text-left text-2xl mb-2 text-white flex p-0 hamburger-menu-item"
                        to="/contact-us"
                      >
                        {t("TITLE_CONTACT_US")}
                      </Link>

                      {!SiteFeatures.CLOSED_SYSTEM && !props.loggedIn && (
                        <div
                          className="mt-6 btn-md	text-white btn btn-ghost bg-primary-400/50 bg-transparent uppercase"
                          onClick={() => {
                            Emitter.emit("LOGIN_MODAL", true);
                          }}
                        >
                          {t("BUTTON_SIGNIN")}
                        </div>
                      )}

                      {props.loggedIn && (
                        <div
                          onClick={() => {
                            setOpen(false);
                            props.logout();
                          }}
                          className="btn btn-ghost text-left mb-2 text-2xl  text-red-500 flex p-0 hamburger-menu-item"
                        >
                          {t("LOGOUT")}
                        </div>
                      )}
                    </ul>
                  </div>
                </div>
              </div>
            )}
          </div>
        </>
      )}
    </Translation>
  );
};

const mapStateToProps = (state, props) => {
  const { authentication, game } = state;
  const { user, loggedIn, currentLang, permissions } = authentication;
  const { sports, games } = game;
  return {
    user,
    loggedIn,
    sports,
    games,
    currentLang,
    permissions,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(logout()),
    UpdateLang: (data) => dispatch(UpdateLang(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MobileDrawer);
